import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Global search ve slash spotlight için ortak cam kabuk.
 * Landing hero ile aynı iz: modül hue'sunda orb, yumuşak border, blur.
 */
export function PaletteShell({
  children,
  footer,
  className,
}: {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "relative isolate overflow-hidden rounded-[28px]",
        "border border-module-accent/15 dark:border-module-accent/20",
        "bg-white/88 dark:bg-gray-950/88 backdrop-blur-2xl",
        "shadow-[0_28px_80px_-24px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.04)]",
        className,
      )}
    >
      <span
        aria-hidden
        className="pointer-events-none absolute -top-24 -left-16 size-56 rounded-full bg-module-accent/25 blur-3xl dark:bg-module-accent/18"
      />
      <span
        aria-hidden
        className="pointer-events-none absolute -bottom-28 -right-8 size-64 rounded-full bg-module-accent/16 blur-3xl dark:bg-module-accent/12"
      />
      <div className="relative">{children}</div>
      {footer ? <div className="relative">{footer}</div> : null}
    </div>
  );
}

export function PaletteKbd({ children }: { children: ReactNode }) {
  return (
    <kbd className="inline-flex h-5 min-w-5 items-center justify-center rounded-md border border-module-accent/20 bg-module-accent-soft px-1.5 font-mono text-[10px] font-medium text-module-accent">
      {children}
    </kbd>
  );
}

export function PaletteFooter({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 border-t border-module-accent/10 px-4 py-2.5 text-[11px] text-text-tertiary dark:border-white/[0.06] dark:text-gray-500">
      {children}
    </div>
  );
}
